﻿import '@styles/app.css'
import { initSite } from '@layout/site'

initSite()
